/*
 * Public API Surface of ngx-big-spinner
 */

export * from './lib/ngx-big-spinner.service';
export * from './lib/ngx-big-spinner.component';
export * from './lib/ngx-big-spinner.module';
